import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ModalVideo from "react-modal-video";
import { Desc, Heading, AnchorTag } from "../../Global/Typography";
// import TheHeartAndSoulImage from "../../../images/Soulace/architectural/locationNew.jpeg";
import VideoIconImage from "../../../images/SoulTree/VideoIconImage.svg";
import "./TheHeartAndSoul.scss";
const TheHeartAndSoulImage =
    "/images/Soulace/architectural/sarjapur-video-banner.jpeg";

export default function TheHeartAndSoul({ inView }) {
    const [isOpen, setOpen] = useState(false);
    return (
        <section
            className={`section my-md-5 py-md-5 ${
                inView ? "inView" : "outView"
            }`}
        >
            <Container className="text-left TheHeartAndSoul">
                <Row>
                    <Col xs={12} md={5} lg={5} xl={4}>
                        <div className="TheHeartAndSoul__content-block">
                            <Heading
                                variant="h1"
                                classList="TheHeartAndSoul__title"
                                text="Location Matters? Yes Of Course!
                "
                            />
                            <Desc
                                classList="TheHeartAndSoul__desc my-3 "
                                text="Sarjapur Road is becoming a popular choice for homebuyers, due to its close proximity to Bangalore’s major IT hubs, International schools and a lively social environment."
                            />
                            {/* <Desc
                                classList="TheHeartAndSoul__desc my-3 "
                                text="Buying a  home in Sarjapur Road can be a good move due to the proposed metro, Peripheral Ring Road (PRR) and the elevated expressway (STRR), which will be completed on fast track by NHAI."
                            /> */}
                            <AnchorTag
                                href="#"
                                classList="TheHeartAndSoul__link mt-4"
                                text="View location video"
                                onClick={() => setOpen(true)}
                            />
                        </div>
                    </Col>
                </Row>
                <div className="TheHeartAndSoul__image-block">
                    <ModalVideo
                        channel="youtube"
                        autoPlay
                        isOpen={isOpen}
                        // videoId="kkAIIuBjHAs"
                        videoId="oica8XvMvlY"
                        onClose={() => setOpen(false)}
                    />
                    <img
                        src={TheHeartAndSoulImage}
                        className="TheHeartAndSoul__image TheHeartAndSoul__image__soulace"
                        alt="Sarjapur the New Bangalore"
                    />
                    <div
                        className="videoIconImage"
                        onClick={() => setOpen(true)}
                    >
                        <img
                            src={VideoIconImage}
                            className="TheHeartAndSoul__videoIcon"
                            alt="TheHeartAndSoul"
                        />
                    </div>
                </div>
            </Container>
        </section>
    );
}
